<template>
  <section
    data-test="search-wizard-accommodation"
    class="accommodation-wizard-summary"
  >
    <translate tag="p"> Accommodation </translate>
    <div class="all-categories">
      <img
        v-if="showAllCategories"
        src="@/assets/images/category-icons/all-categories.svg"
        :alt="$t('Accommodation categories')"
        width="61"
        height="30"
      />
      <selected-categories v-else :selected-ids="selectedCategoryIdsOrAll" />
    </div>
  </section>
</template>

<script lang="ts">
import CATEGORY_MAP from '~/json/catRoot.json'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class AccommodationWizardSummary extends Vue {
  @Prop({ required: true, type: Array })
  categoryIds: string[]

  @Prop({ required: false, type: Boolean, default: false })
  isSearchResults: boolean

  get selectedCategoryIdsOrAll() {
    return this.categoryIds.length
      ? this.categoryIds
      : Object.keys(CATEGORY_MAP)
  }

  get showAllCategories() {
    return (
      this.isSearchResults && this.$isDesktop && this.categoryIds.length === 0
    )
  }
}

export default toNative(AccommodationWizardSummary)
</script>
